// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"2cab0254","666":"49b6a72d"}[chunkId] + ".chunk.css";
};